<template>
  <div
    class="ht300-state-card"
    v-loading="pageLoading"
    element-loading-background="rgba(17, 30, 43, 0.5)"
    :element-loading-text="loadingText"
    @click="handleSubstanceFlow(item.name.split(' ')[0])"
  >
    <div class="title" style="background-image: url('/static/image/ht300/bg.png')">
      {{ item.name }}
    </div>
    <div
      class="value"
      :class="item.state | alarmClass"
      :style="{ borderRight: item.showRightLine ? '2px solid #1c354d' : 'none' }"
    >
      {{ item.value }}
    </div>
    <div class="unit">
      {{ item.unitName }}
    </div>
    <div class="img-box" v-if="item.showImg">
      <img v-if="item.state == 0" src="/static/image/ht300/safe.png" alt="" />
      <img
        v-else-if="item.key === 'faultStatus' && item.state !== 0"
        src="/static/image/ht300/fault.png"
        alt=""
      />
      <img v-else src="/static/image/ht300/alarm.png" alt="" />
    </div>

    <div v-if="item.time" class="time">{{ item.time }}</div>
  </div>
</template>

<script>
import casMixin from '@/mixins/deviceCasMixin';

import { tools } from '../../CT1226/utils';

export default {
  name: 'HT300StateCard',
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  filters: tools,
  mixins: [casMixin],
  data() {
    return {};
  },
  methods: {},
  components: {}
};
</script>

<style scoped lang="scss">
.ht300-state-card {
  cursor: pointer;
  div {
    @include state-textstyle;

    width: 220px;
    text-align: center;
  }
  .title {
    min-width: 220px;
    height: 52px;
    line-height: 52px;
    text-align: center;
    background-repeat: no-repeat;
    background-size: cover;
    color: #fff;
    font-weight: bold;
    font-size: 20px;
  }
  .value {
    font-weight: bold;
    font-size: 50px;
    margin: 10px 0 0 0;
    padding-right: 30px;
  }
  .unit {
    font-weight: bold;
    font-size: 20px;
    color: fff;
    margin-bottom: 10px;
  }
  .img-box {
    img {
      width: 80px;
      height: 80px;
    }
  }
  .time {
    margin-top: 10px;
    font-size: 14px;
    color: #fff;
  }
}
</style>
